export default __webpack_public_path__ + "static/media/sidebar.9dbc5a3a.svg";